// extracted by mini-css-extract-plugin
export default {"landing":"LandingPage_landing__4LGfg","vid":"LandingPage_vid__85Nmd","overlay":"LandingPage_overlay__xF9GX","tittle":"LandingPage_tittle__tmnUM"};